import React, { Fragment, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { useTranslate } from 'react-admin';

interface Props {
    imageDataBase64: string;
    name: string;
    /** The caller titles the signature itself: the name only serves as the image's alternative text. */
    hideName?: boolean;
}

// Adaptation of platform-v2 ShowNoteSignsItem to Material-UI v4
const ShowNoteSignsItem: React.FC<Props> = ({ imageDataBase64, name, hideName }) => {
    const t = useTranslate();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOpen();
        }
    };

    const hasImage = !!imageDataBase64;

    return (
        <Fragment>
            <Box style={{ display: 'grid', gap: 8 }}>
                {!hideName && <Typography>{name}</Typography>}

                {hasImage && (
                    <img
                        onClick={handleOpen}
                        onKeyDown={handleKeyDown}
                        role='button'
                        tabIndex={0}
                        src={imageDataBase64}
                        alt={name || 'signature'}
                        style={{
                            border: '1px solid rgba(0,0,0,0.12)',
                            borderRadius: 4,
                            maxWidth: '100%',
                            cursor: 'pointer',
                        }}
                    />
                )}
            </Box>

            <Dialog open={open} onClose={handleClose} maxWidth='lg' fullWidth>
                <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <BorderColorIcon style={{ marginRight: 8 }} /> {t('app.signs')}
                </DialogTitle>
                <DialogContent dividers>
                    <Box style={{ display: 'grid', justifyContent: 'center', gap: 8 }}>
                        {hasImage && (
                            <img
                                src={imageDataBase64}
                                alt={name || 'signature'}
                                style={{ border: '1px solid rgba(0,0,0,0.12)', borderRadius: 4, maxWidth: '100%' }}
                            />
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='contained' color='primary'>
                        {t('app.main_buttons.return')}
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export default ShowNoteSignsItem;
